import React, { useRef, useState } from 'react';

import serverRenderingUtils from 'helpers/serverRenderingUtils';
import { useCurrentUserCtx } from 'client/contexts/CurrentUser';
import { INTEGRATION_CONNECTION_MENU_MODE } from './constants';
import { IntegrationConnectionScreenStyles } from './styles';
import {
  FAQ,
  Hero,
  LoginSignUp,
  MeetAnchor,
  Process,
  Video,
} from './components';

// TODO https://anchorfm.atlassian.net/browse/CAST-2784: Remove feature flag logic once it has been on production
// for a beat and successful.
const shouldShowRouteBasedOnEnvionment = () => {
  const origin = serverRenderingUtils.windowUndefined()
    ? serverRenderingUtils.getBaseUrl()
    : window.location.origin;
  return (
    origin &&
    (/localhost/.test(origin) ||
      /development.anchor.fm/.test(origin) ||
      /website-(.+).anchor.fm/.test(origin))
  );
};

// TODO https://anchorfm.atlassian.net/browse/CAST-2753: Turn on feature flag when releasing to production
// TODO https://anchorfm.atlassian.net/browse/CAST-2784: Remove feature flag logic once it has been on production
// for a beat and successful.
export const ENABLE_INTEGRATION_CONNECTION_SCREEN =
  false || shouldShowRouteBasedOnEnvionment();

// TODO https://anchorfm.atlassian.net/browse/CAST-2682: When creating the IntegrationRedirectScreen,
// Change the "return_to" links to that screen (i.e. ?return_to=%2Fvideopartner%2Friverside)
export function IntegrationConnectionScreen() {
  const [
    currentAuthFormView,
    setCurrentAuthFormView,
  ] = useState<INTEGRATION_CONNECTION_MENU_MODE>('login');
  const {
    state: { status },
    resetCurrentUser,
  } = useCurrentUserCtx();

  // If the user currently exists, we need to reset the user and have them
  // login or sign up.
  if (status === 'success') {
    resetCurrentUser();
  }

  const loginSignUpRef = useRef<HTMLDivElement>(null);
  const scrollToLoginSignUp = (ref: any) =>
    ref.current.scrollIntoView({ behavior: 'smooth' });

  return (
    <>
      <IntegrationConnectionScreenStyles />
      <div className="pageContainer">
        <Hero />
        <LoginSignUp
          reference={loginSignUpRef}
          currentStatus={currentAuthFormView}
          setCurrentStatus={setCurrentAuthFormView}
        />
        <Process />
        <Video
          onClick={() => scrollToLoginSignUp(loginSignUpRef)}
          currentStatus={currentAuthFormView}
        />
        <MeetAnchor />
        <FAQ />
      </div>
    </>
  );
}
